// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1ejb{gap:var(--ds-space-300,24px)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._10fp1h6o{justify-self:center}\n._18u01jfw{margin-left:var(--ds-space-500,40px)}\n._19pk1jfw{margin-top:var(--ds-space-500,40px)}\n._1wpz1h6o{align-self:center}\n._2hwx1jfw{margin-right:var(--ds-space-500,40px)}\n._4cvr1h6o{align-items:center}\n._6a6z1h6o{justify-items:center}\n._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}", ""]);
// Exports
module.exports = exports;
